// extracted by mini-css-extract-plugin
export default {"root":"IconMessageCircle_root__EiA51"};